'use client';
import { RadioCardGroup, ToggleGroup } from '@baseline/ui';
import { useState } from 'react';
import TermSheetLayout from '@/app/tools/term-sheet/components/TermSheetLayout';
import styles from './termSheetSelect.module.scss';
import { useRouter } from 'nextjs-toploader/app';

export default function TermSheetSelect() {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [selectedTransactionType, setTransactionType] = useState<string | null>(
    null
  );
  const router = useRouter();

  return (
    <TermSheetLayout
      backButtonProps={{
        onClick: () => router.push('/tools/term-sheet')
      }}
      nextButtonProps={{
        disabled: !selectedOption || !selectedTransactionType,
        onClick: () => {
          router.push(
            `/tools/term-sheet/${selectedOption}?transactionType=${selectedTransactionType}`
          );
        }
      }}
    >
      <h1 className={styles.heading}>Loan Details</h1>
      <div className={styles.field}>
        <label className={styles.label}>{'Transaction type'}</label>
        <ToggleGroup
          type="single"
          options={[
            {
              children: 'Purchase',
              value: 'Purchase'
            },
            {
              children: 'Refinance',
              value: 'Refinance'
            }
          ]}
          onValueChange={(value) => setTransactionType(value)}
        />
      </div>
      <div className={styles.field}>
        <label className={styles.label}>{'Loan type'}</label>
        <RadioCardGroup
          value={selectedOption || undefined}
          onValueChange={(value) => setSelectedOption(value)}
          items={[
            {
              label: 'Bridge',
              description:
                'A temporary loan providing interim financing typically used to bridge a financial gap until longer-term financing is secured.',
              value: 'bridge'
            },
            {
              label: 'Residential Transition Loan (RTL)',
              description:
                'Short-term loan for real estate investors purchase, renovating, or repositioning residential properties before sale or refinance.',
              value: 'rtl'
            },
            {
              label: 'Debt Service Coverage Ratio (DSCR)',
              description:
                'Loan based on property cash flow, ideal for financing rental properties.',
              value: 'dscr'
            },
            {
              label: 'Ground Up Construction',
              description:
                'Financing for building new properties, funding land acquisition and construction costs.',
              value: 'guc'
            }
          ]}
        />
      </div>
    </TermSheetLayout>
  );
}
